import React from 'react';

const CompanyHero = () => {
  const stats = [
  { value: '2018', label: 'Grunnlagt' },
  { value: '85K+', label: 'Aktive brukere' },
  { value: '4.2M', label: 'Beregninger/år' },
  { value: '99.8%', label: 'Oppetid' }];


  return (
    <section style={{ padding: '60px 24px 0', maxWidth: '1200px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0', marginBottom: '48px' }}>
        <div style={{ width: '4px', height: '56px', background: '#FF5722', marginRight: '20px', marginTop: '4px', flexShrink: 0 }} />
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#FF5722' }}>Om Veiassistent</span>
            <div style={{ flex: 1, height: '1px', background: 'rgba(255,87,34,0.3)', maxWidth: '60px' }} />
          </div>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(28px, 5vw, 42px)', fontWeight: 700, letterSpacing: '0.02em', color: 'var(--color-foreground)', lineHeight: 1.1, marginBottom: '20px' }}>
            Vi gjør norske veier
            <span style={{ display: 'block', color: '#FF5722' }}>smartere for alle</span>
          </h1>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '17px', fontWeight: 400, color: 'var(--color-muted-foreground)', lineHeight: 1.75, maxWidth: '600px' }}>
            Veiassistent ble grunnlagt med én visjon: å gjøre det enkelt for norske sjåfører og bedrifter å forstå, planlegge og optimalisere sine reiser på norske veier — med full oversikt over bomkostnader, ruter og kjøretøydata.
          </p>
        </div>
      </div>
      {/* Stats row */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '2px', marginBottom: '64px' }}>
        {stats?.map((stat, i) =>
        <div key={i} style={{ padding: '28px 24px', background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'rgba(0,79,152,0.04)', border: '1px solid rgba(224,228,232,0.08)', borderLeft: i === 0 ? '3px solid #FF5722' : '1px solid rgba(224,228,232,0.08)' }}>
            <div style={{ fontFamily: 'var(--font-heading)', fontSize: '32px', fontWeight: 700, color: '#FF5722', letterSpacing: '-0.02em', marginBottom: '6px' }}>{stat?.value}</div>
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 500, color: 'var(--color-muted-foreground)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{stat?.label}</div>
          </div>
        )}
      </div>
      {/* Hero image placeholder */}
      <div style={{ position: 'relative', height: '380px', borderRadius: '2px', overflow: 'hidden', marginBottom: '80px', background: 'rgba(0,79,152,0.08)', border: '1px solid rgba(224,228,232,0.08)' }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1cb0ee648-1772192350752.png"
          alt="Norsk fjordlandskap med vei langs vannet — symboliserer Veiassistents kjernevirksomhet på norske veier"
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.6 }} />
        
        <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, rgba(26,29,32,0.7) 0%, rgba(0,79,152,0.3) 100%)' }} />
        <div style={{ position: 'absolute', bottom: '32px', left: '40px' }}>
          <p style={{ fontFamily: 'var(--font-heading)', fontSize: '22px', fontWeight: 700, color: '#FFFFFF', letterSpacing: '0.02em' }}>Norges ledende bomtjeneste</p>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'rgba(224,228,232,0.7)', marginTop: '6px' }}>Fra Bergen til Tromsø — vi dekker hele landet</p>
        </div>
        <div style={{ position: 'absolute', top: '24px', right: '24px', padding: '8px 16px', background: 'rgba(255,87,34,0.9)', borderRadius: '2px' }}>
          <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FFFFFF' }}>Siden 2018</span>
        </div>
      </div>
    </section>);

};

export default CompanyHero;